import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { selectors } from './selectors';
export * from './model';
export const requestAccountantAccessModel = _object_spread({}, selectors);
